import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=d2506c42&scoped=true&"
import script from "./QRCode.vue?vue&type=script&lang=js&"
export * from "./QRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2506c42",
  null
  
)

export default component.exports